// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3lQe1","head":"ProcedureTableInfo_head__2deyh"};